import React, { Component } from 'react';
import getDisplayName from '../../utils/getDisplayName';

const defaults = {
  placeholder: () => null
};

export default (options = {}) => (WrappedComponent) => class extends Component {
  static displayName =
    `RenderClientSideOnly(${getDisplayName(WrappedComponent)})`;

  constructor(props, context) {
    super(props, context);
    Object.assign(this, defaults, options);
    this.state = { visible: false };
  }

  componentDidMount() {
    if (!this.state.visible) {
      this.setState({ visible: true });
    }
  }

  render() {
    return this.state.visible
      ? <WrappedComponent {...this.props} />
      : this.placeholder();
  }
};
